import { type AxiosProgressEvent, type AxiosResponse } from 'axios';

import { type IAttachedDocumentResponse } from '../../modules/License/types/response';

import { request } from '../requestService';

const ENDPOINTS = {
  attDoc: 'attDoc',
  download: 'download',
};

export function uploadFile(
  data: FormData,
  licenseTypeCode: string,
  onUploadProgress?: (e: AxiosProgressEvent) => void
): Promise<AxiosResponse<IAttachedDocumentResponse[]>> {
  return request({
    method: 'POST',
    url: `${ENDPOINTS.attDoc}/${licenseTypeCode}`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
    transformRequest: (data) => data,
    onUploadProgress,
  });
}

export function downloadAttachment({
  fileURL,
  lpcoId,
  attachmentId,
  isSaved,
}: {
  fileURL?: string;
  lpcoId?: string;
  attachmentId?: number;
  isSaved: boolean;
}): Promise<AxiosResponse<Blob>> {
  const url = isSaved
    ? `${ENDPOINTS.attDoc}/${ENDPOINTS.download}/${attachmentId as number}`
    : `${ENDPOINTS.attDoc}/${ENDPOINTS.download}?fileUrl=${fileURL as string}${lpcoId ? `&id=${lpcoId}` : ''}`;

  return request({
    url,
    responseType: 'blob',
  });
}
